module.exports = __webpack_public_path__ + "static/media/medal.08e83678.png";